"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    theme
  }) => ({
    fontSize: '1.2rem',
    color: theme.palette.grey[500],
    justifyContent: 'center'
  }),
  selectLabel: {
    fontSize: '1.2rem'
  },
  displayedRows: {
    fontSize: '1.2rem'
  },
  actions: {
    display: 'inline-flex',
    gap: 15
  }
};
const defaultProps = {
  // SelectProps: { variant: 'outlined', size: 'small' },
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTablePagination.js.map